<template>
  <div :class="{ 'error': !!errorMsg }">
    <div v-if="label" class="mb-1 font-medium flex gap-1 items-center">
      {{ label }}
      <span v-if="required" class="text-red-600">*</span>
      <pe-tooltip v-if="tooltip" :text="tooltip" icon />
    </div>
    <slot />
    <pe-error-msg :message="errorMsg" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  required?: boolean
  tooltip?: string
  errorMsg?: string
}>()
</script>

<style scoped>

</style>